import { Controller } from "@hotwired/stimulus";

// Fires "action-sheet:open" with a templateId from the element's value.
// Usage: data-controller="action-sheet-trigger"
//        data-action-sheet-trigger-template-value="my-template-id"
//        data-action="click->action-sheet-trigger#fire"
export default class extends Controller {
  static values = { template: String };

  fire(event) {
    event.preventDefault();
    window.dispatchEvent(
      new CustomEvent("action-sheet:open", {
        detail: { templateId: this.templateValue },
      }),
    );
  }
}
